<section class="parker-banner">
  <app-mini-env-banner bgColor="var(--white)" [slides]="bannerSlides"
    (butonAction)="onSliderBtnAction($event)"></app-mini-env-banner>
  <div class="brought d-flex justify-content-center">
    <div>
      <div class="d-flex align-items-center parker-img-row">
        <div class="d-flex align-items-center" style="gap: 10px;">
          <span class="brought-to">Brought to you in Collaboration with</span>
        </div>
        <div>
          <div class="d-flex">
            <div>
              <img class="logo-white" [src]="sharedService.imagesUrl + 'wow-health-logo-white.svg'" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container-fluid services-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'Easy Medicine Access'" [title]="'Fast & Simple Medication Access'"
      [description]="'Access the medications you need without long waits. Simple ordering and trusted delivery you can count on.'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="responsive-tabs mt-20">
      <div class="tab-body">
        <app-mini-env-content-box [imgSrc]="imgSrc">
          <h2 class="content-heading">Pharmacy Services</h2>
          <p class="content-txt">
            Enjoy convenient and cost-effective pharmacy options, designed to make healthcare more accessible when it
            matters most.
          </p>

          <ul class="d-flex content-list">
            <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              <p>
                <span class="bullet-heading">Free Generic Medicine : </span>
                Get 93% of prescriptions at no cost, with
                home delivery for chronic care & local pickup for acute care.
              </p>
            </div>
            <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              <p>
                <span class="bullet-heading">Local Pharmacy Access : </span>
                Pick up all medications at discounted rates from over 70,000 local pharmacies.
              </p>
            </div>
            <div class="list-item"><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt="">
              <p>
                <span class="bullet-heading">Discounted Brand Medication : </span>
                Get brand-name medications at significant discounts from Tier-1 countries (UK, Canada, Australia, New
                Zealand) with free home delivery.
              </p>
            </div>
          </ul>

          <button (click)="getStartedAction()" class="btn btn-primary get-started"> Buy Pharmacy Membership </button>
        </app-mini-env-content-box>
      </div>
    </div>
  </div>
</section>

<section class="container-fluid bg-white avail-benefits">

  <app-mini-env-heading-block [miniTitle]="'How it Works'" [title]="'Your Care, Step by Step'"
    [description]="'We’ve streamlined the process so you don’t have to think twice. From start to finish, everything is designed to be quick and easy.'"
    [style]="'max-width: 684px;'"></app-mini-env-heading-block>

  <app-imagebox-bullet-scroll [steps]="steps" [imgLink]="imgLink"></app-imagebox-bullet-scroll>
</section>

<section class="search-section container-fluid">
  <app-search-medication class= "iac-input" [imgSrc]="medication_bg"></app-search-medication>
</section>

<section class="video-section">
  <div class="container-fluid">

    <app-mini-env-heading-block [miniTitle]="'See WoW Health in Action'" [title]="'A Sneak Peek Inside WoW Health'"
      [description]="'Step inside WoW Health and see what makes us different. Thoughtfully designed to support your health journey every step of the way.'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="container">
      <app-video-player [videoSrc]="
          'https://www.youtube.com/embed/5K9Y9foINlA?si=QhTLjeJXF454oqxt'
        "></app-video-player>
    </div>
  </div>
</section>

<!-- <section class="container-fluid">
    <div class="container">
        <div class="tabs">

            <div class="tab-headers">
                <button
                *ngFor="let pane of panes; let i = index"
                (click)="select(i)"
                [class.active]="pane.active"
                class="tab-btn"
                >
                {{ pane.title }}
                </button>
            </div>

            <div class="tab-body">
                <div *ngFor="let pane of panes; let i = index">
                    <app-mini-env-content-box *ngIf="pane.active" [imgSrc]="imgSrc">
                        <h2 class="content-heading">{{ pane.title }}</h2>
                        <p class="content-txt">
                        Licensed Medics to guide with care decisions, with FREE virtual care.
                        </p>

                        <ul class="d-flex content-list">
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Primary Care:</span> Appointment with the same doctor - no long waiting hours.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Virtual Urgent Care:</span> 24/7 access to virtual care for non-emergency issues.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Tele counseling:</span> 24/7 Mental health and personal life support with specialists.</li>
                            <li><img [src]="sharedService.imagesUrl + 'black-circle-tick.svg'" alt=""><span class="bullet-heading">Message-a-specialist:</span> Quick response on medical concerns via secure chat.</li>
                        </ul>

                        <button class="btn btn-primary">Get Started</button>
                    </app-mini-env-content-box>
                </div>
            </div>

        </div>
    </div>
</section> -->

<section class="container-fluid login-section">
  <app-mini-env-heading-block [title]="'Your Medications Just Got Simplified!'"
    [description]="'Skip the pharmacy lines, and start today with the easy and affordable medications in a few clicks'"
    [style]="'max-width: 749px;'"></app-mini-env-heading-block>
  <button (click)="login()" class="login-btn-redirect">Log In to Get Started</button>
</section>

<section class="container-fluid faq-section">
  <div class="container">

    <app-mini-env-heading-block [miniTitle]="'FAQs'" [title]="'Frequently Asked Questions'"
      [description]="'Need help? Our dedicated customer support team is available 24/7 to answer your questions and provide assistance. Call us anytime at 844-969-4325.'"
      [style]="'max-width: 684px;'"></app-mini-env-heading-block>

    <div class="mt-30">
      <app-mini-env-faqs [faqData]="faqList"></app-mini-env-faqs>
    </div>
  </div>
</section>

<!--  How can we help Section End-->